<template>
    <main class="SectionArtworkCard-MAIN hide-scrollbar">
        <section>

            <ProgressImage class="artworkcard-image" v-if="artworkData?.file"
                :thumbSrc="`${this.$ENDPOINT}/assets/thumbnails_artworks/${artworkData.file}`"
                :fullSrc="`${this.$ENDPOINT}/assets/artworks/${artworkData.file}`"
                :alt="`Artwork ${artworkData.titulo}`"
                @click="fullView = true"
            />

            <!--<img v-if="artworkData?.file" :src="`${this.$ENDPOINT}/assets/artworks/${artworkData.file}`" class="artworkcard-image"/>-->

            <div class="artworkcard-title">
                <p>{{ artworkData.titulo }}</p>
            </div>
            <div class="artworkcard-details">
                <div>
                    <span>ARTISTA</span>
                    <p>{{ artworkData.artist_nombre }} {{ artworkData.artist_apellido }}</p>
                </div>
                <div>
                    <span>MEDIDAS</span>
                    <p>{{ artworkData.medidas_cm?.replaceAll("x", " x ") }}</p>
                </div>
            </div>
            <div>
                <div>
                    <span>TÉCNICA</span>
                    <p>{{ artworkData.tecnica }}</p>
                </div>
            </div>
            <div class="artworkcard-description">
                <span>DESCRIPCIÓN</span>
                <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi provident vitae beatae cumque quod odit praesentium minus deserunt expedita, voluptas explicabo ad, voluptatem maiores vero eos obcaecati perferendis eligendi totam architecto mollitia ut veniam ipsum? Ullam facilis fugit ea molestias adipisci maxime, reprehenderit nesciunt laborum ex dolores sunt tenetur temporibus!</p>
            </div>
            <!--<div class="artworkcard-status">
                <div>
                    <span>ESTADO</span>
                    <p>{{ artworkData.estado }}</p>
                </div>
                <div>
                    <span>PRECIO</span>
                    <p>${{ artworkData.precio_mxn }} MXN</p>
                </div>
            </div>-->
            <button @click="moreInfo()" v-if="!fullView">
                MÁS INFO
            </button>

            <button v-else @click="fullView = false">CERRAR</button>

        </section>

        <section class="artworkcard-full" v-if="fullView">
            <img :src="`${this.$ENDPOINT}/assets/artworks/${artworkData.file}`"/>
        </section>

    </main>
</template>

<script>
import ProgressImage from '@/components/ProgressImage.vue';

export default {
    name: 'SectionArtworkCard',
    components: {
        ProgressImage
    },
    props: {
        id: { type: [String, Number], required: true }
    },
    data(){
        return{
            artworkData: {},
            fullView: false
        }
    },
    methods: {
        moreInfo(){
            this.$router.push({ name: 'contact', params: { id: String(this.id) }, query: { from: 'artwork' } });
        },

        async loadArtwork(){
            const response = await fetch(`${this.$ENDPOINT}/api/get_artwork.php?id=${encodeURIComponent(this.id)}`);
            const result = await response.json();
            if(result.status === "success") this.artworkData = result.artwork;
        }
    },
    mounted(){
        this.loadArtwork();
    },
    watch: {
        id(){
            this.loadArtwork();
        }
    }
}
</script>

<style>
.artworkcard-image, .artworkcard-image img{
    width: 75vw;
    aspect-ratio: 1/1;
    margin: 0 auto;
    margin-top: 2ch;
    margin-bottom: 1ch;
    object-fit: contain;
    object-position: center;
}

.artworkcard-image{
    border: none !important;
}
</style>

<style scoped lang="stylus">
.SectionArtworkCard-MAIN
    background-color: white
    padding-bottom: calc(47px + 6vw + 6vw)
    overflow: auto;
    position: relative

    >section:first-child
        margin: 2vw
        padding: 2vw
        height: calc(100% - 8vw)
        max-height: calc(100% - 8vw)
        font-family: "Archivo ExtraCondensed", sans-serif
        display: flex
        flex-direction: column

        .artworkcard-arr-back
            max-width: 6vw
            max-height: 6vw
            position: fixed
            top: 4vw
            left: 4vw
            z-index 1

        >div
            border-bottom: 1px solid #DCDCDC
            padding: 1ch 0
            display: flex
            justify-content: space-between

            p
                margin: 0
                font-size: 2.8ch

            span
                color: #DCDCDC
                font-size: 2.2ch
                font-family: "DM Mono", monospace

        button
                height: 47px
                width: calc(180px + 18px + 18px)
                background-color: rgb(1, 90, 255)
                border: none
                color: white
                max-width: 75vw
                position: fixed
                margin: auto
                left: 0
                right: 0
                bottom: 6vw
                border-radius: 100vw
                z-index: 1
                font-family: "DM Mono", monospace

.artworkcard-title
    font-size: 3ch

.artworkcard-details
.artworkcard-status
    padding: 2ch 0 !important

    p
        margin-top: 5px !important;

.artworkcard-details > div
    max-width: 45%

.artworkcard-status > div
    max-width: 50%

.artworkcard-description
    display: flex
    flex-direction: column

.artworkcard-full
    position: fixed
    top: 0
    left: 0
    width: 100%
    height: 100dvh
    background-color: rgba(0, 0, 0, 0.5)
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center

    >img
        max-width: calc(100vw - 4vw)
        max-height: calc(100dvh - (47px - 6vw) * 3)
        margin-bottom: calc((47px - 6vw) * 3)
        border-radius: 5px
</style>
